import { createPaginatedSlice } from '../../../helpers/reduxHelper';

const paginatedRequests = createPaginatedSlice('paginatedRequests');

export const paginatedRequestsActions = paginatedRequests.actions;
export const paginatedRequestsSelector = (state) => state.paginatedRequests;
export const paginatedRequestsReducer = paginatedRequests.reducer;
export default paginatedRequestsReducer;

export const paginatedRequestsSelectors = paginatedRequests.LF.selectors;
